import * as React from 'react';
import { connect, Dispatch } from "react-redux";
import { IApplicationState, AppActionCreators, IAlleleOverrideResponse, AlleleOverrideActionCreators, FileActionCreators } from "@nkr/store/index";
import { IBaseResponse } from '@nkr/models/index';
import { IAlleleOverride } from '@nkr/models/hla/index';
import { RouteComponentProps } from 'react-router';
import { TableWrapper, TableHeadWrapper } from '../swap-management/styles';
import AlleleUpdateRow from './allele-update-row';
import { downloadFile } from '@nkr/services/download-file';
import { FileDocumentType, FileDocumentTypeDescription } from '@nkr/enums/document-type';
import { toast } from 'react-toastify';

interface IOwnProps extends RouteComponentProps<{ id: string }> { }

interface IProps { }

interface IStateProps { }

interface IState {
    list: IAlleleOverride[]
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getAlleleOverrides: () => Promise<IAlleleOverrideResponse>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;


class Hla extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading Allele Overrides, one moment please...').then(() => {
            this.props.getAlleleOverrides().then(response => {
                this.setState({
                    list: response.data.results
                });

                this.props.hideLoading();
            });
        });
    }


    handleGetFile = (docType: FileDocumentType, donorId: number) => {
        this.props.downloadFile(docType, donorId).then((response: any) => {
            downloadFile(response.data, `${FileDocumentTypeDescription[docType]}.pdf`, response.headers.contentType)
        }).catch((error: IBaseResponse) => {
            toast.error("Unable to download file at this time.  Please contact support.");
        })
    }

    render() {
        const alleleList = this.state.list;

        return (
            <>
                <div className='container'>
                    <div style={{ marginTop: 10 }}>
                        <h3>Alleles Pending Update</h3>
                    </div>
                    <hr></hr>

                    <TableWrapper fontSize={12} condensed striped>
                        <TableHeadWrapper>
                            <tr>
                                <th>Allele Id</th>
                                <th colSpan={2}>Actions</th>
                            </tr>
                        </TableHeadWrapper>
                        <tbody>
                            {alleleList.length == 0 && (
                                <tr><td colSpan={3}>There are no updates...</td></tr>
                            )}

                            {alleleList.map(item => <AlleleUpdateRow alleleOverride={item} onGetFile={this.handleGetFile} />)}
                        </tbody>
                    </TableWrapper>
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        centerList: appState.centers.list
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getAlleleOverrides: () => { return dispatch(AlleleOverrideActionCreators.getAlleleOverrides()); },
        downloadFile: (docType, id) => {
            return dispatch(FileActionCreators.downloadFile(docType, id))
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Hla)